import { render } from "./ToolsProcessView.vue?vue&type=template&id=33594fa9&scoped=true&ts=true"
import script from "./ToolsProcessView.vue?vue&type=script&lang=ts"
export * from "./ToolsProcessView.vue?vue&type=script&lang=ts"

import "./ToolsProcessView.vue?vue&type=style&index=0&id=33594fa9&lang=scss&scoped=true"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33594fa9"]])

export default __exports__